class GlobalRequestService {

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.activeControllers = [];
    }

    cancelAll() {
        this.activeControllers.forEach((controller) => controller.abort());
        this.activeControllers = [];
    }
}

export default GlobalRequestService;
